import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type GetParametersResponce } from '../services/parameterConfigurations'

export interface parameterConfigurationState {
  isLoading: boolean
  loadingError: string | null
  parameters: GetParametersResponce | undefined
  httpStatus: number | null
}

const initialState: parameterConfigurationState = {
  isLoading: true,
  loadingError: null,
  parameters: undefined,
  httpStatus: null
}

const parameterConfigurationsSlice = createSlice({
  name: 'parameterConfigurations',
  initialState,
  reducers: {
    parameterConfigurationLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        parameters: undefined,
        httpStatus: 0
      }
    },
    parameterConfigurationUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: null,
        parameters: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    parameterConfigurationErrorAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        parameters: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  parameterConfigurationLoadingAction,
  parameterConfigurationUpdateAction,
  parameterConfigurationErrorAction
} = parameterConfigurationsSlice.actions

export default parameterConfigurationsSlice.reducer
